import { CurrentUser } from 'types/user';

import React from 'react';

import UserAvatar from 'components/UserAvatar';

import * as styles from './AvatarBanner.css';

interface AvatarBannerProps {
  user: CurrentUser;
  message: string;
  className?: string;
}

const AvatarBanner: React.FC<AvatarBannerProps> = ({ user, message, className }) => {
  return (
    <div className={`${styles.banner} ${className || ''}`}>
      <UserAvatar avatarUrl={user.avatarUrl} size="sm" userId={user.id} username={user.fullName} />
      <p className={styles.bannerText}>{message}</p>
    </div>
  );
};

export default AvatarBanner;
